<template>
  <div v-for="item in productStore.product?.attribute_variations" :key="item.label" class="mt-6">
    <UiText type="p" size="sm">{{ `${item.label}:` }}</UiText>
    <div class="flex flex-row gap-2">
      <div v-for="variation in item.variations" :key="variation.label" class="mt-2">
        <UiChip
          :id="`product-variant-${variation.value}`"
          size="sm"
          :value="variation.value"
          :label="variation.label"
          :type="isColor(variation.value) ? 'color' : 'text'"
          :selected="productStore.selectedAttributes[item.label] === variation.value"
          @click="() => productStore.selectVariantAttribute(item.label, variation.value)"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useProductStore } from '~/stores/product/productStore';

const isColor = (value: string): boolean => {
  return /^#[0-9A-F]{6}[0-9a-f]{0,2}$/i.test(value);
};

const productStore = useProductStore();
</script>
